// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import * as Flag$BenfaerberBlog from "../components/Flag.bs.js";
import * as AppContext$BenfaerberBlog from "../AppContext.bs.js";
import * as Translation$BenfaerberBlog from "../Translation.bs.js";
import * as ReactRouterDom$BenfaerberBlog from "../wrappers/ReactRouterDom.bs.js";

function s(prim) {
  return prim;
}

function Header(props) {
  var match = React.useState(function () {
        
      });
  var setActive = match[1];
  var active = match[0];
  var $$location = ReactRouterDom.useLocation();
  var match$1 = React.useContext(AppContext$BenfaerberBlog.context);
  var translate = match$1.translate;
  React.useEffect((function () {
          setActive(function (param) {
                return $$location.pathname;
              });
        }), [$$location]);
  var getClassNames = function (name) {
    var isActive = Js_string.includes(name, Belt_Option.getWithDefault(active, ""));
    var activeClass = isActive ? "active" : "";
    return Js_array.joinWith(" ", [
                "navbar-item",
                "folder-tab",
                "color-1",
                activeClass
              ]);
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("nav", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(ReactRouterDom$BenfaerberBlog.Link.make, {
                                        children: "Blog",
                                        href: "/blog",
                                        className: getClassNames("blog")
                                      }),
                                  JsxRuntime.jsx(ReactRouterDom$BenfaerberBlog.Link.make, {
                                        children: translate(Translation$BenfaerberBlog.Labels.projects),
                                        href: "/projects",
                                        className: getClassNames("projects")
                                      }),
                                  JsxRuntime.jsx(ReactRouterDom$BenfaerberBlog.Link.make, {
                                        children: translate(Translation$BenfaerberBlog.Labels.aboutMe),
                                        href: "/about-me",
                                        className: getClassNames("about-me")
                                      })
                                ],
                                className: "navbar-start"
                              }),
                          className: "navbar-menu"
                        }),
                    className: "navbar main-nav"
                  }),
              className: "header-desktop"
            });
}

var make = Header;

export {
  s ,
  make ,
}
/* react Not a pure module */
